<div style="position: relative">
  <i class="ico-calendar calender-icon" aria-hidden="true"></i>
  @if (!editMode && control.value) {
    <div
      (click)="editMode = !editMode"
      class="input-box input-box--border input-box--no-icon encrypted"
    >
      {{ control.value?.day | encrypt: 'X' : 0 }}/{{
        control.value?.month | encrypt: 'X' : 0 : 2
      }}/{{ control.value?.year | encrypt: 'X' : 0 }}
    </div>
  }
  @if (!editMode && !control.value) {
    <div
      (click)="editMode = !editMode"
      class="input-box input-box--border input-box--no-icon encrypted ng-invalid"
    >
      XX/XX/XXXX
    </div>
  }
  @if (editMode) {
    <input
      autocomplete="off"
      appInput
      [border]="true"
      [navigation]="'select'"
      (click)="d.toggle()"
      ngbDatepicker
      #d="ngbDatepicker"
      name="{{ name }}"
      id="{{ name }}"
      [readonly]="disabled"
      [attr.aria-label]="name | splitCamelCase"
      [formControl]="control"
      [container]="'body'"
      [maxDate]="maxDate"
      [minDate]="minDate"
      firstDayOfWeek="7"
    />
  }
</div>
